export const COLORS = {
  BgPrimary: "#120e38",
  BgSecondary: "#147fad",
  TxtPrimary: "#120e38",
  TxtSecondary: "#147fad",
  BtnPrimarycolor:"#1468fb",
  BgPrimarySection:"#f8f7f7",
  BgSecondarySection:"#fafafa"
};
